










































































import {Component, Vue} from 'vue-property-decorator';
import {
  Action,
  Getter,
} from 'vuex-class';

@Component
export default class SignUp extends Vue {
  public $refs!: {
    form: any,
  };

  private user: any = {};
  private loading: boolean = false;
  @Getter('common/rules/all') private rules!: any;
  @Getter('guest/auth/username') private username!: any;
  @Getter('guest/auth/password') private password!: any;
  @Getter('guest/auth/oldPassword') private oldPassword!: any;

  @Action('guest/auth/signIn') private signIn!: any;
  @Action('guest/auth/forgotPassword') private forgotPassword!: any;
  @Action('guest/auth/forgotPasswordSubmit') private forgotPasswordSubmit!: any;
  @Action('guest/auth/resendSignUp') private resendSignUp!: any;
  @Action('guest/auth/confirmSignUp') private confirmSignUp!: any;

  private mounted() {
    if (this.username) {
      this.user.username = this.username;
    }
    if (this.oldPassword) {
      this.user.oldPassword = this.oldPassword;
    }
  }

  private async Confirm(e) {
    e.preventDefault();
    if (this.$refs.form.validate()) {
      this.loading = true;
      const res = await this.forgotPasswordSubmit(this.user);
      if (res) {
        if (await this.signIn(this.user)) {
          this.$router.push({name: 'UserBase'});
        } else {
          this.$router.push({name: 'SignIn'});
        }
      }
      this.loading = false;
    }
  }

  private async RequestCode(e) {
    e.preventDefault();
    if (this.user.username) {
      this.loading = true;
      await this.forgotPassword(this.user);
      this.loading = false;
    }
  }
}
